import { prop } from 'ramda';
import { useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';

import * as server from '../server';
import * as actions from '../store/actions';
import { useAppSelector } from 'js/store/hooks';

export const useGetPaymentsConfiguration = () => {
    const dispatch = useDispatch();
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async () => {
        const response = await server.getPaymentsConfiguration(casinoName);
        const paymentsConfig = response?.data?.casinoConfiguration?.casino;

        // for backbone compatibility
        dispatcher.dispatch('user:getPaymentsConfiguration:success', response);

        dispatch(actions.userSetAttributesAction({ paymentsConfig }));

        return paymentsConfig;
    }, [casinoName, dispatch]);
};
